import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const CareerApi = createApi({
  reducerPath: "CareerApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["CAREERAPI"],
  endpoints: (build) => ({
    // Get all applications (Admin only)
    getAllApplications: build.query({
      query: ({ page, status }) => ({
        url: `/careers?page=${page}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CAREERAPI"],
    }),

    // Get application by ID (Admin only)
    getApplicationById: build.query({
      query: ({ id }) => ({
        url: `/careers/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["CAREERAPI"],
    }),

    // Create new application (Public route)
    createApplication: build.mutation({
      query: (formData) => ({
        url: `/careers`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["CAREERAPI"],
    }),

    // Update application (Admin only)
    updateApplication: build.mutation({
      query: ({ id, data }) => ({
        url: `/careers/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["CAREERAPI"],
    }),

    // Update application status (Admin only)
    updateApplicationStatus: build.mutation({
      query: ({ id, status }) => ({
        url: `/careers/${id}/status`,
        method: "PUT",
        body: { status },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CAREERAPI"],
    }),

    // Download resume (Admin only)
    downloadResume: build.query({
      query: ({ id }) => ({
        url: `/careers/${id}/resume`,
        method: "GET",
        headers: {},
      }),
      providesTags: ["CAREERAPI"],
    }),

    // Delete application (Admin only)
    deleteApplication: build.mutation({
      query: ({ id }) => ({
        url: `/careers/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["CAREERAPI"],
    }),
  }),
});

export const {
  useGetAllApplicationsQuery,
  useGetApplicationByIdQuery,
  useCreateApplicationMutation,
  useUpdateApplicationMutation,
  useUpdateApplicationStatusMutation,
  useDownloadResumeQuery,
  useLazyDownloadResumeQuery,
  useDeleteApplicationMutation,
} = CareerApi;
